import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, doc, query, orderBy } from "firebase/firestore";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate(); // 🔥 Navigasyon için

  // Durum seçenekleri dizisi
  const orderStatuses = ["inProgress", "completed", "canceled", "refunded"];

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersQuery = query(collection(db, "orders"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(ordersQuery);
        const ordersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOrders(ordersData);
      } catch (error) {
      }
    };

    fetchOrders();
  }, []);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const orderRef = doc(db, "orders", orderId);
      await updateDoc(orderRef, { status: newStatus });
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? { ...order, status: newStatus } : order
        )
      );
    } catch (error) {
    }
  };

  return (
    <div>
      <h2>Siparişler</h2>
      {/* 🚀 Abonelikler sayfasına gitme butonu */}
      <button onClick={() => navigate("/subscriptions")}>Aboneliklere Git</button>

      {orders.length === 0 ? <p>No orders available.</p> : null}
      {orders.map((order) => (
        <div key={order.id} style={{ border: "1px solid black", padding: "10px", margin: "10px 0" }}>
          <p><strong>Sipariş Veren:</strong> {order?.addressSnapshot?.name || "Bilinmeyen Kullanıcı"}</p>
          <p><strong>Adres:</strong> {order?.addressSnapshot?.full_address || "No address available"}</p>
          <p><strong>Şehir:</strong> {order?.addressSnapshot?.city || "Unknown city"}</p>
          <p><strong>İlçe:</strong> {order?.addressSnapshot?.district || "Unknown district"}</p>
          
          {/* 📌 Siparişteki tüm ürünleri listeleme */}
          <p><strong>Ürünler:</strong></p>
          <ul>
            {order.cartItems && order.cartItems.length > 0 ? (
              order.cartItems.map((item, index) => (
                <li key={index}>
                  {item.product?.name || "No product info"} - {item.product?.brand || "Unknown Brand"}
                </li>
              ))
            ) : (
              <li>No products available</li>
            )}
          </ul>

          <p><strong>Tarih:</strong> {order.createdAt?.seconds ? new Date(order.createdAt.seconds * 1000).toLocaleString() : "Geçersiz Tarih"}</p>

          {/* 📌 Sipariş Durumu Seçimi */}
          {orderStatuses.map((status) => (
            <label key={status} style={{ marginRight: "10px" }}>
              <input
                type="radio"
                name={`status-${order.id}`}
                checked={order.status === status}
                onChange={() => handleStatusChange(order.id, status)}
              />
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </label>
          ))}
        </div>
      ))}
    </div>
  );
};

export default OrdersPage;
